import { KLAVIYO_DEFAULT_METRIC_NAME } from "@babackapp/tracking-status-registry";
import { Send } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { KlaviyoActionNodeEditor } from "./editor";
import { KlaviyoActionNodePanel } from "./panel";

const newNodeDefaultConfig: { metricName: string } = {
  metricName: KLAVIYO_DEFAULT_METRIC_NAME,
};

const newNodeDefaultValue: any = {
  actionType: "send_klaviyo_event",
  config: newNodeDefaultConfig,
};

export default registerNode<any["data"]>({
  type: "action:send_klaviyo_event",
  name: "workflowsEditor.nodes.sendKlaviyoEvent.title",
  description: "workflowsEditor.nodes.sendKlaviyoEvent.description",
  Icon: Send,
  category: NodeCategory.ACTION,
  color: "green",
  editor: {
    component: KlaviyoActionNodeEditor,
  },
  configPanel: {
    component: KlaviyoActionNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue,
});

export { KlaviyoActionNodeEditor } from "./editor";
export { KlaviyoActionNodePanel } from "./panel";
